import React from 'react';
import { Menu, MenuItem, Paper } from '@mui/material';

interface AppBarMenuProps {
  menuItems: any;
  menuId: string;
  anchorEl: HTMLElement | undefined | null;
  setAnchorEl: (anchorEl: null | HTMLElement) => void;
}

export function AppBarDesktopMenu({
  menuItems,
  menuId,
  anchorEl,
  setAnchorEl,
}: AppBarMenuProps) {
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{ mt: 4 }}
    >
      {menuItems.map((item: any) => {
        return (
          <MenuItem
            key={item.value}
            onClick={item.onClick}
            data-testid="logout"
          >
            {item.text}
          </MenuItem>
        );
      })}
    </Menu>
  );
}
